<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <br />
    <v-card class="card">
      <v-card-title class="heading justify-center">Proctor Duty List</v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="3">
              <label>Academic Year</label>
              <v-select
                v-model="current_academic_year"
                :items="ay_list"
                item-text="name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="3">
              <label>Semester</label>
              <v-select
                v-model="current_semester"
                :items="sem_list"
                item-text="name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="3">
              <label>Exam</label>
              <v-select
                v-model="current_exam"
                :items="exam_list"
                item-text="name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn class="button" @click="get_data">Fetch Data</v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <br />
    <v-card class="card" v-if="list_of_duties !=''">
      <v-card-text>
        <template>
          <v-data-table
            :headers="headers"
            :items="list_of_duties"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Appointed Duties</v-toolbar-title>
                <v-divider class="mx-10" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <span style="width: 20px;"></span>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn v-if="item.enable_flag == true"
                class="button"
                @click="proceed(item)"
              >Proceed for Proctoring</v-btn>
              <v-btn disabled v-else class="button">Exam is not Active</v-btn>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
    <br />
    <!-- <v-card class="card" v-if="list_of_exams !=''">
      <v-card-text>
        <template>
          <v-data-table
            :headers="time_table_headers"
            :items="list_of_exams"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Exam Time Table</v-toolbar-title>
                <v-divider class="mx-10" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <span style="width: 20px;"></span>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                class="button"
                rounded
                @click="proceed(item)"
              >Proceed for Proctoring</v-btn>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card> -->
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data() {
    return {
      ay_list: [],
      sem_list: [],
      exam_list: [],
      current_academic_year: "",
      current_semester: "",
      current_exam: "",
      list_of_duties: "",
      // list_of_exams: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      headers: [
        { text: "Sr.No.", value: "srno" },
        { text: "Exam Date ", value: "exam_date" },
        { text: "Slot No.", value: "slot_no" },
        { text: "Start Time", value: "start_time" },
        { text: "End Time", value: "end_time" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      // time_table_headers: [
      //   { text: "Sr.No.", value: "srno" },
      //   { text: "Exam Date ", value: "exam_date" },
      //   { text: "Slot No.", value: "slot_no" },
      //   { text: "Start Time", value: "start_time" },
      //   { text: "End Time", value: "end_time" },
      //   { text: "Actions", value: "actions", sortable: false, align: "center" },
      // ],
    };
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    get_data() {
      if (this.current_exam == "") {
        this.showSnackbar("#b71c1c", "Please select the exam!"); // show snackbar
      } else {
        const data = {
          ay: this.current_academic_year,
          semester: this.current_semester,
          exam: this.current_exam.id,
        };
        // console.log(data.ay + " " + data.semester + " " + data.exam);
        axios
          .post("Proctor/fetchData", data)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.proctor_session_list != "") {
                this.list_of_duties = res.data.proctor_session_list;
              } else {
                this.list_of_duties = "";
                this.showSnackbar("#b71c1c", "Protor Duty not found for selected Exam!"); // show snackbar
              }
              // if (res.data.schduled_exam_list != "") {
              //   this.list_of_exams = res.data.schduled_exam_list;
              // } else {
              //   this.list_of_exams = "";
              //   this.showSnackbar("#b71c1c", "Exam Time Table not found!"); // show snackbar
              // }
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          // .finally(() => {
          //   this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          //   window.console.log(error);
          // });
      }
    },
    proceed(val) {
      console.log("val: "+val)
      this.$store.commit('setproctor_session_id', val.id)
      this.$router.push({ name: 'proctor-live-dashboard', target:"blank"})
    },
  },
  mounted() {
    axios
      .get("/Proctor/proctorDutyHome")
      .then((res) => {
        if (res.data.msg == "200") {
          this.ay_list = res.data.ay_list;
          this.sem_list = res.data.sem_list;
          this.exam_list = res.data.array_of_exam_list;
          this.current_academic_year = res.data.current_ay;
          this.current_semester = res.data.current_sem;
          // this.current_exam = res.data.current_exam;
        }
      })
      .catch((error) => {
        window.console.log(error);
      });
  },
};
</script>

<style>
.card {
  border: 2px solid hsla(190, 99%, 30%, 1) !important;
}
/* .button {
  background-color: hsla(190, 99%, 30%, 1) !important;
  color: white;
} */
</style>